export default class ZeroWaste {
    constructor() {
        this.title = 'Tutorial: Predicting Amazon Review Ratings'
        this.galleryImage = 'AmznPredictionsCover'
        this.linkOut = 'https://gist.github.com/martinRoss/cd6493231899c434bd94f6ccea28c607'
    }
}



// WEBPACK FOOTER //
// ./src/components/projects/active/PredictingAmazonRatings.js